import { render, staticRenderFns } from "./r-currency-formula-dialog.vue?vue&type=template&id=1f03c7cd&scoped=true"
import script from "./r-currency-formula-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-formula-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-currency-formula-dialog.vue?vue&type=style&index=0&id=1f03c7cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03c7cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f03c7cd')) {
      api.createRecord('1f03c7cd', component.options)
    } else {
      api.reload('1f03c7cd', component.options)
    }
    module.hot.accept("./r-currency-formula-dialog.vue?vue&type=template&id=1f03c7cd&scoped=true", function () {
      api.rerender('1f03c7cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-formula-dialog.vue"
export default component.exports